<template>
  <div class="p-0 container__form-job-status">
    <p class="label__form-job-status-header">Choose your current job status</p>
    <b-form-group ref="form__job-status-on-boarding" class="m-0">
      <div class="radio-item">
        <b-form-radio v-model="form.job_status" name="radio-student" value="STUDYING">
          <b-img
            :src="require(`../../../assets/on-boarding/icon-form-onboarding/icon-student.svg`)"
            alt="Student"
          />
          <span>Student</span>
        </b-form-radio>
      </div>

      <div class="radio-item">
        <b-form-radio v-model="form.job_status" name="working-professional-radios" value="WORKING">
          <b-img
            :src="require(`../../../assets/on-boarding/icon-form-onboarding/icon-work.svg`)"
            alt="Student"
          />
          <span>Working professional</span>
          <WorkingProfessionalChecked
            v-if="form.job_status === 'WORKING'"
            ref="form__job-working-professional"
            @submit:working-professional="onSetWorkingProfessional"
          />
        </b-form-radio>
      </div>
      <div class="radio-item">
        <b-form-radio v-model="form.job_status" name="not-listed-above-radios" value="UNSPECIFIED">
          <b-img
            :src="require(`../../../assets/on-boarding/icon-form-onboarding/icon-not-listed.svg`)"
            alt="Student"
          />
          <span>Not listed above</span>
        </b-form-radio>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import WorkingProfessionalChecked from './WorkingProfessionalChecked.vue';

export default {
  components: {
    WorkingProfessionalChecked
  },
  data() {
    return {
      form: {
        job_status: 'STUDYING',
        company: null,
        area_of_employment: null
      }
    };
  },
  methods: {
    onSubmitJobStatus() {
      if (this.form.job_status === 'WORKING' && this.$refs['form__job-working-professional']) {
        this.$refs['form__job-working-professional'].updateWorkingChecked();
      } else {
        this.$set(this.form, 'company', null);
        this.$set(this.form, 'area_of_employment', null);
      }

      this.$emit('submit:job-status', this.form);
    },

    onSetWorkingProfessional(form) {
      this.$set(this.form, 'company', form.company);
      this.$set(this.form, 'area_of_employment', form.area_of_employment);
    }
  }
};
</script>

<style lang="scss">
.container__form-job-status {
  .label__form-job-status-header {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 1.5rem;
  }

  .radio-item {
    align-items: center;
    padding: 1rem 1.5rem;
    margin-bottom: 1rem;
    font-size: 16px;
    box-shadow: 0px 4px 8.8px 0px #a6a6b98c;
    border-radius: 10.4px;

    img {
      margin-right: 0.75rem;
      margin-left: 10px;
    }

    .custom-control-label {
      width: 100%;
      padding: 0 !important;
      margin: 0;
      cursor: pointer;
    }
  }

  .text_feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f83245;
  }
}
</style>
